export default __webpack_public_path__ + "media/images/icons/chat-baloons-5554270bdf0a7691d234c0f359b2cc1e.svg";